import React, { ChangeEvent, useState } from 'react';
import {
  FormControl,
  FormLabel,
  Icon,
  RedAsterix,
  SearchPickerTagInput,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import useRiskObjectsForPartyList from '../../../../../hooks/useRiskObjectsForPartyList';
import useCreationFlowReport from '../../../../../hooks/useCreationFlowReport';
import useAddInsuranceModalContext from '../../../hooks/useAddInsuranceModalContext';
import { useFieldArray } from 'react-hook-form';
import { InsuranceDetailFormValues } from '../../../../../types/Form';
import { Option } from '../../../../../../../../../design-system/src/content/components/SearchPickerInput';
import { uniqBy } from 'lodash';
import useRiskObjectInputStore from '@parties/src/features/risk-objects/store/riskObjectInputStore';

const RiskObjectInputComponent: React.FC = () => {
  const setFocusedInput = useRiskObjectInputStore(
    (state) => state.setFocusedInput,
  );
  const { t } = useTranslation();
  const [inputSearchValue, setInputSearchValue] = useState<string>('');
  const { data: report } = useCreationFlowReport();
  const { fields, replace } = useFieldArray<
    InsuranceDetailFormValues,
    'coverages'
  >({
    name: 'coverages',
  });
  const { data, isLoading } = useRiskObjectsForPartyList(
    report?.party?.id || '',
  );

  const options = data;
  const { riskObjects, setRiskObjects, customRiskObjects } =
    useAddInsuranceModalContext();

  const handleChange = (values: Option[]) => {
    /** When removing a riskobject it will filter out the coverages that were linked to the risk object */
    replace(
      fields.filter(({ risk_object }) =>
        values.some(({ label }) => label === risk_object),
      ),
    );
    setRiskObjects(values);
  };
  const filteredOptions = uniqBy(
    [...customRiskObjects, ...options],
    'label',
  ).filter(({ label }) =>
    label?.toLowerCase().includes(inputSearchValue.toLocaleLowerCase()),
  );

  return (
    <FormControl>
      <FormLabel>
        {t(`RISKS`)} <RedAsterix />
      </FormLabel>
      <SearchPickerTagInput
        h="10"
        setSelectedOptions={handleChange}
        onAdd={() => setInputSearchValue('')}
        options={filteredOptions.length ? filteredOptions : undefined}
        selectedOptions={riskObjects}
        searchValue={inputSearchValue}
        leftIcon={<Icon name="GeneralActionsSearch" />}
        placeholder={t('DEFAULT_MULTISELECT_OPTIES')}
        borderColor="gray.100"
        isLoading={isLoading}
        onBlur={() => setFocusedInput(null)}
        onFocus={() => setFocusedInput('coverages')}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setInputSearchValue(e.currentTarget.value)
        }
      />
    </FormControl>
  );
};

export default RiskObjectInputComponent;
